// Curated Google Fonts list available across the Design Mode.
// The family name MUST match Google Fonts exactly so the loader URL works.
export interface FontOption {
  family: string;
  label: string;
  category: "sans" | "serif" | "display" | "mono";
  weights: number[];
}

export const FONT_OPTIONS: FontOption[] = [
  { family: "Inter", label: "Inter", category: "sans", weights: [400, 500, 600, 700, 800] },
  { family: "Poppins", label: "Poppins", category: "sans", weights: [400, 500, 600, 700, 800] },
  { family: "Roboto", label: "Roboto", category: "sans", weights: [400, 500, 700, 900] },
  { family: "Open Sans", label: "Open Sans", category: "sans", weights: [400, 600, 700, 800] },
  { family: "Lato", label: "Lato", category: "sans", weights: [400, 700, 900] },
  { family: "Montserrat", label: "Montserrat", category: "sans", weights: [400, 500, 600, 700, 800] },
  { family: "Nunito", label: "Nunito", category: "sans", weights: [400, 600, 700, 800] },
  { family: "Raleway", label: "Raleway", category: "sans", weights: [400, 500, 600, 700, 800] },
  { family: "DM Sans", label: "DM Sans", category: "sans", weights: [400, 500, 700] },
  { family: "Space Grotesk", label: "Space Grotesk", category: "sans", weights: [400, 500, 600, 700] },
  { family: "Quicksand", label: "Quicksand", category: "sans", weights: [400, 500, 600, 700] },
  { family: "Manrope", label: "Manrope", category: "sans", weights: [400, 500, 600, 700, 800] },
  { family: "Work Sans", label: "Work Sans", category: "sans", weights: [400, 500, 600, 700] },
  { family: "Playfair Display", label: "Playfair Display", category: "serif", weights: [400, 500, 600, 700, 800] },
  { family: "Merriweather", label: "Merriweather", category: "serif", weights: [400, 700, 900] },
  { family: "Lora", label: "Lora", category: "serif", weights: [400, 500, 600, 700] },
  { family: "Cormorant Garamond", label: "Cormorant Garamond", category: "serif", weights: [400, 500, 600, 700] },
  { family: "Bebas Neue", label: "Bebas Neue", category: "display", weights: [400] },
  { family: "Oswald", label: "Oswald", category: "display", weights: [400, 500, 600, 700] },
  { family: "Anton", label: "Anton", category: "display", weights: [400] },
  { family: "Archivo Black", label: "Archivo Black", category: "display", weights: [400] },
  { family: "JetBrains Mono", label: "JetBrains Mono", category: "mono", weights: [400, 500, 700] },
];

const loadedFonts = new Set<string>();

export const ensureFontLoaded = (family: string) => {
  if (!family || loadedFonts.has(family)) return;
  const opt = FONT_OPTIONS.find((f) => f.family === family);
  if (!opt) return;
  loadedFonts.add(family);
  const weights = opt.weights.join(";");
  const url = `https://fonts.googleapis.com/css2?family=${family.replace(/ /g, "+")}:wght@${weights}&display=swap`;
  const link = document.createElement("link");
  link.rel = "stylesheet";
  link.href = url;
  link.setAttribute("data-design-font", family);
  document.head.appendChild(link);
};

export const FONT_WEIGHT_OPTIONS = [
  { value: "300", label: "Light" },
  { value: "400", label: "Normal" },
  { value: "500", label: "Medium" },
  { value: "600", label: "Semi-bold" },
  { value: "700", label: "Bold" },
  { value: "800", label: "Extra-bold" },
];
